import { useState, useEffect } from "react";

export function FormMachines() {
  const [dotCount, setDotCount] = useState(1);
  const [rotation, setRotation] = useState(0);

  // Animated dots for the loading indicator
  useEffect(() => {
    const interval = setInterval(() => {
      setDotCount((prev) => (prev < 3 ? prev + 1 : 1));
    }, 500);

    return () => clearInterval(interval);
  }, []);

  // Subtle background rotation effect
  useEffect(() => {
    const rotateInterval = setInterval(() => {
      setRotation((prev) => (prev + 0.2) % 360);
    }, 50);

    return () => clearInterval(rotateInterval);
  }, []);

  // Interactive hover effect for the button
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-indigo-50 to-blue-100 p-4">
      <div className="relative">
        <div
          className="absolute -z-10 w-64 h-64 bg-blue-300 rounded-full opacity-20 blur-3xl"
          style={{ transform: `rotate(${rotation}deg)` }}
        />
        <div
          className="absolute -z-10 w-64 h-64 bg-indigo-400 rounded-full opacity-20 blur-3xl -translate-x-16 translate-y-8"
          style={{ transform: `rotate(${-rotation}deg)` }}
        />
      </div>

      <div className="bg-white bg-opacity-70 backdrop-blur-lg rounded-xl shadow-lg p-8 md:p-12 max-w-md text-center z-10 border border-white">
        <h1 className="text-4xl font-bold text-gray-800 mb-2">
          Under Development
        </h1>
        <div className="flex justify-center mb-6">
          <div className="h-1 w-16 bg-blue-500 rounded-full"></div>
        </div>

        <p className="text-xl text-gray-700 mb-8">
          Coming Soon{Array(dotCount).fill(".").join("")}
        </p>

        <button
          className={`px-6 py-3 rounded-full text-white font-medium transition-all duration-300 ${
            isHovered
              ? "bg-indigo-600 shadow-lg shadow-indigo-200 -translate-y-1"
              : "bg-blue-500 shadow-md"
          }`}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          Notify Me
        </button>

        <p className="text-gray-500 mt-8 text-sm">
          We're working hard to bring you something amazing.
        </p>
      </div>
    </div>
  );
}
